<script>
  import ContentSwitcher from "lib/components/ContentSwitcher.svelte";
  import UsersList from "../../settings/UsersList.svelte";
  import AdminUserHistory from "./AdminUserHistory.svelte";
  import TeamsList from "../../settings/TeamsList.svelte";
  import GroupsList from "../../settings/GroupsList.svelte";
  import AdminClientManagement from "./AdminClientManagement.svelte";

  const accessSectionOptions = [
    "User Management",
    "User History",
    "Team Management",
    "Permission Management",
    "Client Management",
  ];
  let activeAccessSection = 0;
</script>

<div class="access-management">
  <div class="access-section-switcher">
    <ContentSwitcher
      options={accessSectionOptions}
      bind:selected={activeAccessSection}
      fitContent
    />
  </div>

  {#if activeAccessSection === 0}
    <div class="user-management-list">
      <UsersList embedded />
    </div>
  {:else if activeAccessSection === 1}
    <AdminUserHistory />
  {:else if activeAccessSection === 2}
    <div class="user-management-list">
      <TeamsList embedded />
    </div>
  {:else if activeAccessSection === 3}
    <div class="user-management-list">
      <GroupsList embedded />
    </div>
  {:else}
    <div class="user-management-list">
      <AdminClientManagement />
    </div>
  {/if}
</div>

<style>
  .access-management {
    display: flex;
    flex-direction: column;
    gap: var(--control-gap);
  }

  .access-section-switcher {
    max-width: 100%;
    overflow-x: auto;
  }

  .user-management-list {
    margin: -1rem;
  }

  :global(.embedded-toolbar) {
    display: flex;
    justify-content: flex-end;
    gap: var(--control-gap);
    margin-bottom: var(--control-gap);
  }
</style>
